import React from "react";
import _ from "lodash";
import numeral from "numeral";
import {
  parseTableData,
  filterDataToGroup,
} from "../IntegrationVerificationHelper";
import GroupDataTable from "./GroupDataTable";
import FilterControl from "./FilterControl";

class TrafficAllocationView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      records: [],
      columns: [],
      groups: [],

      filterGroups: [],
      filterRecords: [],
      filterAmount: null,

      tags: [],
    };

    this.handleSearch = this.handleSearch.bind(this);
  }

  componentDidMount() {
    const {
      dataList: [data3, data4, data5],
    } = this.props;

    const tempColumns = [
      data5.columns[0],
      "key20_request",
      "key27_request",
      "key33_request",
    ];

    const arrangeCol = [
      {
        key: "date",
        label: "Date",
        groupfunc: (list) => {
          const temp = _.union(list);
          return temp.length > 1 ? "--" : temp[0];
        },
      },
      {
        key: "key20_request",
        label: "key20 #",
        groupfunc: (list) => {
          return _.sum(_.filter(list, (d) => _.isNumber(d)));
        },
        format: (val) => {
          return numeral(val).format("0,0");
        },
        align: "text-right",
      },
      {
        key: "key27_request",
        label: "key27 #",
        groupfunc: (list) => {
          return _.sum(_.filter(list, (d) => _.isNumber(d)));
        },
        format: (val) => {
          return numeral(val).format("0,0");
        },
        align: "text-right",
      },
      {
        key: "key27_key20_ratio",
        label: "ratio-1",
        parsefunc: ({ key20_request, key27_request }) => {
          return key20_request === 0 ||
            key20_request === "-" ||
            key27_request === "-"
            ? 0
            : key27_request / key20_request;
        },
        format: (val) => {
          return numeral(val).format("0.00%");
        },
      },
      {
        key: "key33_request",
        label: "key33 #",
        groupfunc: (list) => {
          return _.sum(_.filter(list, (d) => _.isNumber(d)));
        },
        format: (val) => {
          return numeral(val).format("0,0");
        },
        align: "text-right",
      },
      {
        key: "key33_key20_ratio",
        label: "ratio-2",
        parsefunc: ({ key20_request, key33_request }) => {
          return key20_request === 0 ||
            key20_request === "-" ||
            key33_request === "-"
            ? 0
            : key33_request / key20_request;
        },
        format: (val) => {
          return numeral(val).format("0.00%");
        },
      },
    ];

    const newRecords = [];
    const indexMap = new Map();

    const dateIdx = _.indexOf(data5.columns, "date");
    const k20Idx = _.indexOf(data5.columns, "key20_request_v2");
    _.forEach(data5.records, (item) => {
      const date = item[dateIdx];
      const k20val = item[k20Idx];

      let index = indexMap.get(date);

      if (index === undefined) {
        newRecords.push([date, 0, 0, 0]);
        index = newRecords.length - 1;
        indexMap.set(date, index);
      }

      newRecords[index][1] += k20val;
    });

    const d3reqIdx = _.indexOf(data3.columns, "request_v2");
    const d3keyIdx = _.indexOf(data3.columns, "key_value");
    _.forEach(data3.records, (item) => {
      const date = item[dateIdx];
      const val = item[d3reqIdx];
      const kval = item[d3keyIdx];

      let index = indexMap.get(date);
      if (index !== undefined && /^(i|b|a|u\d)$/.test(kval)) {
        newRecords[index][2] += val;
      }
    });

    const d4reqIdx = _.indexOf(data4.columns, "request_v2");
    const d4keyIdx = _.indexOf(data4.columns, "key_value");
    _.forEach(data4.records, (item) => {
      const date = item[dateIdx];
      const val = item[d4reqIdx];
      const kval = item[d4keyIdx];

      let index = indexMap.get(date);
      if (
        index !== undefined &&
        !kval.toString().includes("o_") &&
        kval !== ""
      ) {
        newRecords[index][3] += val;
      }
    });

    const result = parseTableData({
      columns: tempColumns,
      arrangeColumns: arrangeCol,
      records: newRecords,
      mainKey: "date",
    });

    this.setState({
      ...result,
      columns: arrangeCol,
      filterGroups: result.groups,
      filterRecords: result.records,
      filterAmount: result.amount,
      tags: arrangeCol.slice(1).map((item) => ({
        value: item.key,
        label: item.label,
        group: item.group,
      })),
    });
  }

  handleSearch(expression) {
    const { records, columns } = this.state;

    const result = filterDataToGroup({
      expression,
      records,
      columns,
    });

    if (result) {
      this.setState({
        ...result,
      });
    }
  }

  render() {
    const { filterAmount, filterGroups, filterRecords, columns, tags } =
      this.state;

    return (
      <>
        <div className="mb-2">
          <FilterControl
            tags={tags}
            handleSearch={this.handleSearch}
          ></FilterControl>
        </div>
        <GroupDataTable
          records={filterRecords}
          groups={filterGroups}
          amount={filterAmount}
          mainKey="date"
          columns={columns}
        ></GroupDataTable>
      </>
    );
  }
}

export default TrafficAllocationView;
